import { render, staticRenderFns } from "./Gatilhos.vue?vue&type=template&id=1e3ae416&scoped=true"
import script from "./Gatilhos.vue?vue&type=script&lang=js"
export * from "./Gatilhos.vue?vue&type=script&lang=js"
import style0 from "./Gatilhos.vue?vue&type=style&index=0&id=1e3ae416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3ae416",
  null
  
)

export default component.exports